import { CustomFormTemplate, FpCompany, User } from '@flicent/fieldpulse-react-component-library-frontend';

import { ApiServiceInstance } from './Api.service';


interface RequestParams {
  id: number;
  token: string;
}

interface ResponseDataType extends CustomFormTemplate {
  max_page_count: number;
  user: User;
  company: FpCompany;
  template: CustomFormTemplate;
}

export const getCustomFormTemplateRequest = ({ id, token }: RequestParams): Promise<ResponseDataType> => {
  return ApiServiceInstance.makeRequest(`/custom-form-template/${ id }`, {
    token,
  });
};